/**
 * @fileoverview Reusable card component for information sections in detail modals
 */
import React from "react";
import PropTypes from "prop-types";
import { DmsAltBox } from "dmsbasereact";
import { Typography } from "@mui/material";

/**
 * Card wrapper for information sections using DmsAltBox
 */
export const DmsInfoCard = ({ icon = null,
  title,
  children}) => (
  <DmsAltBox.Card>
    <DmsAltBox.Header>
      <Typography variant="h6" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {icon} {title}
      </Typography>
    </DmsAltBox.Header>
    <DmsAltBox.Body>
      {children}
    </DmsAltBox.Body>
  </DmsAltBox.Card>
);

DmsInfoCard.propTypes = {
  /** Icon element to display before title */
  icon: PropTypes.node,
  /** Card title */
  title: PropTypes.string.isRequired,
  /** Card content */
  children: PropTypes.node.isRequired,
};

export default DmsInfoCard;
